import { Chart } from 'chart.js';
import {
  getChartFont,
  setupActivityComparisonChart,
  setupActivityRadarChart,
  setupVotesChart,
  setupVotingChart,
} from './charts';
import { ChartSettings } from './types';

export function setupCharts(): void {
  const chartElements = document.getElementsByClassName('chart');

  for (const chartElement of chartElements) {
    setupChart(chartElement as HTMLElement);
  }
}

function setupChart(chartElement: HTMLElement): void {
  const chartSettingsJson = chartElement.dataset.settings!;
  const chartSettings: ChartSettings = JSON.parse(chartSettingsJson);
  const chartContext = chartElement.getElementsByTagName('canvas')[0];

  Chart.defaults.font = getChartFont();

  if (chartSettings.type === 'votes') {
    setupVotesChart(chartContext, chartSettings);
  } else if (chartSettings.type === 'activity-radar') {
    setupActivityRadarChart(chartContext, chartSettings);
  } else if (chartSettings.type === 'activity-comparison') {
    setupActivityComparisonChart(chartContext, chartSettings);
  } else if (chartSettings.type === 'voting') {
    setupVotingChart(chartContext, chartSettings);
  }
}
